module.exports = __webpack_public_path__ + "static/media/menu.b8e68937.svg";